import { getABoostValue as r } from "./index21.mjs";
const s = () => window.location.hash, d = (t, o, e, n) => {
  var a;
  const c = {
    event: t,
    type: typeof o == "function" ? o(n || "") : o,
    screen: s(),
    ads_source: r("ads_source") || "",
    ...e
  };
  (a = window.dataLayerTagManager) == null || a.push(c);
};
export {
  d as track
};
